// src/pages/SignupPage.tsx
import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import AuthLayout from './AuthLayout';

const VerifyUserPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [token, setToken] = useState<string>('');
  // Get a specific query parameter
  const queryValue = searchParams.get('token');
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (queryValue) {
      setToken(queryValue);
      // You can add logic here to verify the token with your backend
      console.log('Verification token:', queryValue);
    } else {
      console.error('No verification token found in URL');
    }
  }, [queryValue]);

  useEffect(() => {
    // This effect runs when the component mounts or when the token changes
    if (token) {
      console.log('Token for verification:', token);
      // Here you can call your backend API to verify the user with the token
      // For example: verifyUser(token);
      verifyUser(token);
    }
  }, [token]);
  
  const verifyUser = async (token: string) => {
    try {
      const response = await fetch('/.netlify/functions/verify-user', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ token: token }),
      });

      if (!response.ok) {
        throw new Error('Verification failed');
      }

      const data = await response.json();
      if(data.success) {
        //redirect to login
        console.log('User verified successfully:', data.message);
        setLoading(false);
        setError(null);
        setTimeout(() => {
          window.location.href = '/login';
        }, 2000); // Redirect after 2 seconds
      } else {
        setLoading(false);
        console.error('Verification error:', data.error);
        setError('Verification failed. Please try again later.');
      }
      
    } catch (error) {
      setLoading(false);
      console.error('Error verifying user:', error);
      setError('Verification failed. Please try again later.');
    }
  };

  return (
    <AuthLayout title="Join the league where last place is legendary" showBackButton={false} showFooter={false}>
      <div className="">
        {
          loading ? (
            <>
              <div className="flex justify-center items-center h-full w-full">
                  <div className="w-8 h-8 border-4 border-[#18f7b1] border-t-transparent rounded-full animate-spin" />
              </div>
              <p className="text-center text-gray-500">
                Verifying your account, please wait...
              </p>
            </>
          ) : (
              error === null ? (
                <div className="text-center">
                <h2 className="text-2xl font-bold mb-4">Verification Complete</h2>
                <p className="mb-4">Your account has been successfully verified!</p>
                </div>
              ) : (
                <div className="text-center">
                <h2 className="text-2xl font-bold mb-4">Verification Failed</h2>
                <p className="mb-4">{error}</p>
                </div>
              )
          )
        }
        
      </div>
    </AuthLayout>
  );
};

export default VerifyUserPage;
